import "./NewsletterSection.css";
import { ArrowRight } from "lucide-react";

const NewsletterSection = () => {
  return (
    <section className="newsletter-section">

      <div className="newsletter-container">

        <span className="newsletter-badge">
          NEWSLETTER
        </span>

        <h2>Stay Ahead of What's Next</h2>

        <p>
          Get practical insights on design, development, technology, and
          digital experiences delivered to your inbox.
        </p>

        <form className="newsletter-form">

          <input
            type="email"
            placeholder="Enter your email address"
          />

          <button type="submit">
            Subscribe
            <ArrowRight size={18}/>
          </button>

        </form>

      </div>

    </section>
  );
};

export default NewsletterSection;